// TypeScript : types pour la réponse du dashboard parent
import { ApiResponse, getFromServer } from "server";

interface TimeData {
  hours: number;
  minutes: number;
  seconds: number;
}

interface TimeStats {
  lastWeek: Record<string, TimeData>;
  currentWeek: Record<string, TimeData>;
}

interface WeeklyTimeStats {
  lastMonth: Record<string, TimeData>;
  currentMonth: Record<string, TimeData>;
}

interface MonthlyTimeStats {
  lastYear: Record<string, TimeData>;
  currentYear: Record<string, TimeData>;
}

export interface ParentChildStats {
  childName: string;
  stats: {
    totalCount: number;
    statusCount: {
      in_standby: number;
      in_processing: number;
      resolved: number;
      rejected: number;
    };
    subjectDistribution: {
      [key: string]: number;
    };
    daylyTimeSpent: TimeStats;
    weeklyTimeSpent: WeeklyTimeStats;
    monthlyTimeSpent: MonthlyTimeStats;
  };
}

export interface ParentDashboardStatsResponse {
  childrenStats: ParentChildStats[];
}

// Interface pour les données de timing des enfants (format réel du backend)
export interface ChildTimingStats {
  childName: string;
  stats: {
    daylyTimeSpent: TimeStats;
    weeklyTimeSpent: WeeklyTimeStats;
    monthlyTimeSpent: MonthlyTimeStats;
  };
}

export interface ParentTimingResponse {
  childrenStats: ChildTimingStats[];
}

// Route : GET /problems/mine/stats
export async function getParentDashboardStats(): Promise<
  ApiResponse<ParentDashboardStatsResponse>
> {
  return await getFromServer<ParentDashboardStatsResponse>(
    "/problems/mine/stats",
  );
}

// Route : GET /statistics/timing - Pour récupérer les données de timing des enfants
export async function getParentChildrenTiming(): Promise<
  ApiResponse<ParentTimingResponse>
> {
  return await getFromServer<ParentTimingResponse>("/statistics/timing");
}
